import UserHttp from "./UserHttp";
import Aes from "./Aes";

export default class User {
  user=null
  static instance = null;
  static getInstance() {
    if (!User.instance) {
      User.instance = new User();
    }
    return User.instance;
  }
  initUser(){
    const that = this;

    return new Promise((resolve,reject)=>{
      const token = localStorage.getItem("token");
      if(!token){
        reject("token is null");
        return;
      }
      UserHttp.get("index/getUser",{},(res)=>{
        if(res.code){
          that.user = res.data//JSON.parse(Aes.decrypt(res.data,token));
          resolve(that.user);
        }else{
          reject(res.msg);
        }
      })
    })
  }
  getUser(){
    return this.user;
  }
  isRole(role_ids) {
    const that = this;
    if (!that.user) {
      return 0;
    }

    if (!Array.isArray(role_ids)) {
      role_ids = role_ids.split(",");
    }
    let role = (that.user.role_ids || "").split(",");
    return role_ids.some(role_id => role.includes(role_id));
  }
}



// WEBPACK FOOTER //
// ./src/common/user/User.js